import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getShelfPackages, getAllSuites } from "../../../../helper/functions";
import { setRequests } from "../../../../store/commonSlice";

/**
 * Custom hook to fetch and manage packages data
 * @param {Object} selectedFilters - Current filter state
 * @returns {boolean} Loading state
 */
export const usePackagesData = (selectedFilters) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const getPackages = async () => {
    try {
      setLoading(true);
      const shelfPackage = await getShelfPackages([]);
      console.log(shelfPackage, "shelfPackageshelfPackage");

      // Extract unique suite IDs
      const usersMySuites = [];
      shelfPackage.forEach((pack) => {
        if (pack?.mySuiteId && !usersMySuites.includes(pack?.mySuiteId)) {
          usersMySuites.push(pack?.mySuiteId);
        }
      });

      // Build filter conditions
      const extra = [];
      if (selectedFilters?.routePartnerId) {
        extra.push({
          key: "routePartnerId",
          operator: "==",
          value: selectedFilters?.routePartnerId,
        });
      }
      if (selectedFilters?.warehouseId) {
        extra.push({
          key: "routePartnerMainAddressId",
          operator: "==",
          value: selectedFilters?.warehouseId,
        });
      }

      console.log(usersMySuites, "usersMySuitesusersMySuites");

      // Fetch suites if we have suite IDs
      if (usersMySuites?.length > 0) {
        const allSuites = await getAllSuites([
          ...extra,
          {
            key: "__name__",
            operator: "in",
            value: usersMySuites,
          },
        ]);
        console.log(allSuites, "allSuitesallSuites");
        dispatch(setRequests(allSuites));
      } else {
        dispatch(setRequests([]));
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching packages:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  return loading;
};

